import { Component, inject } from '@angular/core';
import { ContactsService } from '@services/contacts.services';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss'],
  standalone: false,
})
export class SupportComponent {
  private contactService = inject(ContactsService);
  email = this.contactService.email;
  phone = this.contactService.phone;
}
